import UnsignedInt32 from './Integers/UnsignedInt32';
export default function asUnsignedInt32(value) {
    return new UnsignedInt32(value);
}
